import { CreateProcessConnectionRequestSchema, CreateProcessConnectionResponseSchema } from './create-process-connection.schema';
export const createProcessConnectionContract = {
    method: 'POST',
    path: '/api/v2/process/connections',
    description: 'Create a connection between an output port of one process and an input port of another',
    requestSchema: CreateProcessConnectionRequestSchema,
    responseSchema: CreateProcessConnectionResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized',
            404: 'Process or port not found',
            409: 'Duplicate connection'
        }
    }
};

//# sourceMappingURL=create-process-connection.contract.js.map